import { Star } from 'lucide-react';

const REVIEWS = [
  {
    rating: 5,
    text: '"My daughter loves her new electric car! Amazing quality and fast delivery. KiddieJoy is my go-to store!"',
    name: 'Sarah Johnson',
    role: 'Mom of 2',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg',
    cardGrad: 'from-primary/5 to-accent1/5',
    border:   'border-primary/10',
  },
  {
    rating: 5,
    text: '"Educational toys are fantastic! My son learns while having fun. Great prices and service!"',
    name: 'Michael Chen',
    role: 'Dad of 1',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg',
    cardGrad: 'from-accent2/5 to-accent3/5',
    border:   'border-accent2/10',
  },
  {
    rating: 4.5,
    text: '"Beautiful dresses and top-notch quality! My kids look adorable. Highly recommend!"',
    name: 'Emily Rodriguez',
    role: 'Mom of 3',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg',
    cardGrad: 'from-secondary/5 to-accent1/5',
    border:   'border-secondary/10',
  },
];

function Stars({ rating }) {
  return (
    <div className="flex items-center gap-1 text-secondary text-lg mb-6">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`w-5 h-5 ${n <= Math.floor(rating) ? 'fill-current' : n - 0.5 <= rating ? 'fill-current opacity-60' : 'opacity-25'}`} />
      ))}
    </div>
  );
}

export default function TestimonialSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-textDark mb-4">What Parents Say 💬</h2>
          <p className="text-xl text-textLight">Real stories from happy families</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {REVIEWS.map((r) => (
            <div key={r.name} className={`bg-gradient-to-br ${r.cardGrad} rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all border-2 ${r.border}`}>
              <Stars rating={r.rating} />
              <p className="text-textDark text-lg leading-relaxed mb-6">{r.text}</p>
              <div className="flex items-center gap-4">
                <img src={r.avatar} alt={r.name} className="w-14 h-14 rounded-full object-cover border-4 border-white shadow-md" />
                <div>
                  <p className="font-black text-textDark">{r.name}</p>
                  <p className="text-sm text-textLight">{r.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
